
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-thankyou",
      function () {
        return require("private-next-pages/tnpsc-thankyou/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-thankyou"])
      });
    }
  